let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("d73iZ")).then(() => parcelRequire('b0htF'));